export function tab() {
  const tab01 = document.querySelector('.js-tab01');
  if(tab01) {
    const triggers = tab01.querySelectorAll('.js-tab01--trigger');
    const panels = tab01.querySelectorAll('.js-tab01--panel');

    const Tabswitch = (trigger, panel) => {
      triggers.forEach(element => {
        element.classList.remove('is-active');
      });
      panels.forEach(element => {
        element.classList.remove('is-active');
      });

      trigger.classList.add('is-active');
      panel.classList.add('is-active');
    }

    for (let index = 0; index < triggers.length; index++) {
      const trigger = triggers[index];
      trigger.addEventListener('click', function() {
        const targetId = this.dataset.target;
        const target = document.getElementById(targetId);
        Tabswitch(this,target);
      })
    }

    /*-------------------------
    遷移時にURLがハッシュ（アンカー）を持っている場合に、
    data-targetとIDと一致する要素にそれぞれ「is-active」クラスを再設定
    -------------------------*/
    document.addEventListener("DOMContentLoaded", function() {

      // URLのハッシュ（アンカー）を取得
      var hash = window.location.hash;

      if(hash){

        // ハッシュからIDを取得
        var id = hash.substring(1); // 先頭の#を除去

        // 指定されたクラスを持つ要素から「is-active」クラスを削除
        var triggerElements = document.querySelectorAll('.js-tab01--trigger');
        triggerElements.forEach(function(element) {
            element.classList.remove("is-active");
        });

        var panelElements = document.querySelectorAll('.js-tab01--panel');
        panelElements.forEach(function(element) {
            element.classList.remove("is-active");
        });

        // ハッシュと同じIDの要素があれば、「is-active」クラスを追加
        var targetElement = document.getElementById(id);
        if (targetElement) {
            targetElement.classList.add("is-active");
        }

        // data-target属性が一致する要素にも「is-active」クラスを追加
        var dataTargetElements = document.querySelectorAll('[data-target="' + id + '"]');
        dataTargetElements.forEach(function(element) {
            element.classList.add("is-active");
        });

        if (hash === "#office_pipe") {
          // 「system」IDの要素を取得してアクティブにする
          var systemTab = document.getElementById('office');
          if (systemTab) {
              systemTab.classList.add("is-active");
          }
  
          // 'data-target="system"'を持つ要素をアクティブにする
          var dataTargetElements = document.querySelectorAll('[data-target="office"]');
          dataTargetElements.forEach(function(element) {
              element.classList.add("is-active");
          });
  
          system_pipeの要素にスクロールする
          var targetElement = document.getElementById('office_pipe');
          if (targetElement) {
              setTimeout(function() {
                  targetElement.scrollIntoView({ behavior: 'smooth' });
              }, 100); // DOMの更新後にスクロール
          }
        }
      }
    });
    /*-------------------------
    data-anchor 会社概要ページ内アンカー処理
    -------------------------*/
    const buttons = document.querySelectorAll('button[data-anchor]');
    if(buttons){
      buttons.forEach(button => {
        button.addEventListener('click', function() {
            const anchorId = this.getAttribute('data-anchor');
            console.log('ID' + anchorId);
            // 指定されたクラスを持つ要素から「is-active」クラスを削除
            var triggerElements = document.querySelectorAll('.js-tab01--trigger');
            triggerElements.forEach(function(element) {
                element.classList.remove("is-active");
            });

            var panelElements = document.querySelectorAll('.js-tab01--panel');
            panelElements.forEach(function(element) {
                element.classList.remove("is-active");
            });
            
            if (anchorId === '#office_pipe' || anchorId === '#office_system') {

              var systemTab = document.getElementById('office');
              if (systemTab) {
                  systemTab.classList.add("is-active");
              }
      
              // 'data-target="system"'を持つ要素をアクティブにする
              var dataTargetElements = document.querySelectorAll('[data-target="office"]');
              dataTargetElements.forEach(function(element) {
                  element.classList.add("is-active");
              });

              const anchorElement = document.querySelector(anchorId);
              if (anchorElement) {
                anchorElement.scrollIntoView({ behavior: 'auto' });
              }

            } else if (anchorId === '#group') {

              var systemTab = document.getElementById('group');
              if (systemTab) {
                  systemTab.classList.add("is-active");
              }
      
              // 'data-target="system"'を持つ要素をアクティブにする
              var dataTargetElements = document.querySelectorAll('[data-target="group"]');
              dataTargetElements.forEach(function(element) {
                  element.classList.add("is-active");
              });

              const anchorElement = document.querySelector(anchorId);
              if (anchorElement) {
                anchorElement.scrollIntoView({ behavior: 'auto' });
              }

           }
        });
      });
    }
  }


  const tab02 = document.querySelector('.js-tab02');
  if(tab02) {
    const triggers = tab02.querySelectorAll('.js-tab02--trigger');
    const panels = tab02.querySelectorAll('.js-tab02--panel');

    const Tabswitch = (trigger, panel) => {
      triggers.forEach(element => {
        element.classList.remove('is-active');
      });
      panels.forEach(element => {
        element.classList.remove('is-active');
      });

      trigger.classList.add('is-active');
      panel.classList.add('is-active');
    }

    for (let index = 0; index < triggers.length; index++) {
      const trigger = triggers[index];
      trigger.addEventListener('click', function() {
        const targetId = this.dataset.target;
        const target = document.getElementById(targetId);
        Tabswitch(this,target);
      })
    }
  }

  const tab03 = document.querySelector('.js-tab03');
  if(tab03) {
    const triggers = tab03.querySelectorAll('.js-tab03--trigger');
    const panels = tab03.querySelectorAll('.js-tab03--panel');

    const Tabswitch = (trigger, panel) => {
      triggers.forEach(element => {
        element.classList.remove('is-active');
      });
      panels.forEach(element => {
        element.classList.remove('is-active');
      });

      trigger.classList.add('is-active');
      panel.classList.add('is-active');
    }

    for (let index = 0; index < triggers.length; index++) {
      const trigger = triggers[index];
      trigger.addEventListener('click', function() {
        const targetId = this.dataset.target;
        const target = document.getElementById(targetId);
        Tabswitch(this,target);
      })
    }
  }
}